import React, { useEffect, useState } from 'react';
import { api, apiError } from '../../lib/api';

export default function AdminCategories() {
  const [cats, setCats] = useState([]);
  const [subs, setSubs] = useState([]);
  const [newCat, setNewCat] = useState({ name:'', icon:'' });
  const [newSub, setNewSub] = useState({ category_id:'', name:'' });
  const [err, setErr] = useState('');

  const load = async () => {
    const [c, s] = await Promise.all([api.get('/categories'), api.get('/subcategories')]);
    setCats(c.data.categories || []);
    setSubs(s.data.subcategories || []);
  };
  useEffect(() => { load(); }, []);

  const addCat = async (e) => {
    e.preventDefault(); setErr('');
    try { await api.post('/admin/categories', newCat); setNewCat({ name:'', icon:'' }); await load(); }
    catch (e) { setErr(apiError(e)); }
  };
  const addSub = async (e) => {
    e.preventDefault(); setErr('');
    try { await api.post('/admin/subcategories', { category_id: Number(newSub.category_id), name: newSub.name }); setNewSub({ category_id:'', name:'' }); await load(); }
    catch (e) { setErr(apiError(e)); }
  };
  const delCat = async (c) => { if (window.confirm('Delete category?')) { await api.delete(`/admin/categories/${c.id}`); await load(); } };
  const delSub = async (s) => { if (window.confirm('Delete subcategory?')) { await api.delete(`/admin/subcategories/${s.id}`); await load(); } };

  return (
    <div data-testid="admin-categories">
      <h2 className="mb-3">Categories</h2>
      {err && <div className="alert alert-danger">{err}</div>}
      <div className="row g-3">
        <div className="col-lg-6">
          <div className="ap-card">
            <h4>Categories</h4>
            <form onSubmit={addCat} className="d-flex gap-2 mb-3" data-testid="add-category-form">
              <input className="form-control" placeholder="Name" required value={newCat.name} onChange={e=>setNewCat({...newCat, name:e.target.value})} data-testid="cat-name" />
              <input className="form-control" placeholder="Icon (optional)" value={newCat.icon} onChange={e=>setNewCat({...newCat, icon:e.target.value})} style={{maxWidth:160}} data-testid="cat-icon" />
              <button className="btn-ap" data-testid="cat-add-btn">Add</button>
            </form>
            <table className="ap-table">
              <thead><tr><th>Name</th><th>Slug</th><th># biz</th><th></th></tr></thead>
              <tbody>
                {cats.map(c => (
                  <tr key={c.id}>
                    <td>{c.name}</td><td className="small text-muted-2">{c.slug}</td><td>{c.business_count}</td>
                    <td><button className="btn btn-sm text-danger" onClick={()=>delCat(c)} data-testid={`del-cat-${c.id}`}>Delete</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="ap-card">
            <h4>Subcategories</h4>
            <form onSubmit={addSub} className="d-flex gap-2 mb-3" data-testid="add-subcategory-form">
              <select className="form-select" required value={newSub.category_id} onChange={e=>setNewSub({...newSub, category_id:e.target.value})} data-testid="sub-cat">
                <option value="">Select category</option>
                {cats.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
              <input className="form-control" placeholder="Subcategory name" required value={newSub.name} onChange={e=>setNewSub({...newSub, name:e.target.value})} data-testid="sub-name" />
              <button className="btn-ap" data-testid="sub-add-btn">Add</button>
            </form>
            <table className="ap-table">
              <thead><tr><th>Name</th><th>Category</th><th></th></tr></thead>
              <tbody>
                {subs.map(s => (
                  <tr key={s.id}>
                    <td>{s.name}</td><td className="small text-muted-2">{s.category_name}</td>
                    <td><button className="btn btn-sm text-danger" onClick={()=>delSub(s)} data-testid={`del-sub-${s.id}`}>Delete</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
